export function formatCard(value) {
  if (!value) return null;
  return "**** **** **** " + value.substring(12);
}
